<div class="ng-special-filter-container">
    <div class="ng-special-filter-title">{{ messages.sortToursText }}</div>
    <button type="button"
            class="ng-sort-btn btn-clear"
            [class.active]="currentSort === SORT_BY_PRICE"
            (click)="selectSort(SORT_BY_PRICE)">
        <span class="ng-sort-title">{{ messages.sortByPriceText }}</span>
    </button>
    <button type="button"
            class="ng-sort-btn btn-clear"
            [class.active]="currentSort === SORT_BY_SALES"
            (click)="selectSort(SORT_BY_SALES)">
        <span class="ng-sort-title">{{ messages.sortByPopularText }}</span>
    </button>
    <button type="button"
            class="ng-sort-btn btn-clear"
            [class.active]="currentSort === SORT_BY_RATING"
            (click)="selectSort(SORT_BY_RATING)">
        <span class="ng-sort-title">{{ messages.sortByRatingText }}</span>
    </button>
    <button type="button"
            class="ng-sort-btn btn-clear"
            [class.active]="currentSort === SORT_BY_WRATING"
            (click)="selectSort(SORT_BY_WRATING)">
        <span class="ng-sort-title">{{ messages.sortByWratingText }}</span>
    </button>
    <button type="button"
            class="ng-sort-btn btn-clear"
            [class.active]="currentSort === SORT_BY_PRICE_QUALITY"
            (click)="selectSort(SORT_BY_PRICE_QUALITY)">
        <span class="ng-sort-title">{{ messages.sortByPriceQualityText }}</span>
    </button>
    <template #helpPopover></template>
</div>
